<div
  class="inlineEditDiv"
  id="commonNumericEditor"
  *ngIf="!typeColumn"
  [ngClass]="{'focused':  from != 'project-pages-inline' && isInputFocused,'checkProductLoss' : from == 'prodLossDes' ,'blurred': from != 'project-pages-inline'
  && !isInputFocused, inlineEditEOL: (activatedRoute == 'end-of-life' || activatedRoute == 'organizationPreferences') ? true : false}"
>
  <input
    [ngStyle]="{'color': isInputFocused ? '#9747ff' : '#000000'}"
    #input
    class="simple-input-editor"
    [maxlength]="params.colDef.colId == 'NoOfTrip' ? 4 : (params.colDef.colId == 'percentageOfReuse' ? 6 : 30)"
    (keypress)="onKeyDown($event)"
    title="{{value}}"
    [(ngModel)]="value"
    type="text"
    (paste)="onPaste($event)"
    (click)="manageFocus()"
    (input)="onInput($event)"
    (blur)="onInputBlur($event)"
    [disabled]="from == 'prodLossDes'"
    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
  />
</div>
<div
  class="inlineEditDiv"
  id="commonNumericEditor"
  *ngIf="typeColumn"
  [ngClass]="{'focused':  from != 'project-pages-inline' && isInputFocused,'checkProductLoss' : from == 'prodLossDes' ,'blurred': from != 'project-pages-inline'
  && !isInputFocused, inlineEditEOL: (activatedRoute == 'end-of-life' || activatedRoute == 'organizationPreferences') ? true : false}"
>
  <input
    [ngStyle]="{'color': isInputFocused ? '#9747ff' : '#000000'}"
    #input
    class="simple-input-editor"
    title="{{value}}"
    [(ngModel)]="value"
    type="text"
    (click)="manageFocus()"
    (blur)="onInputBlur($event)"
  />
</div>
